import { loadSshSettings } from "../../terminal/TerminalContext"

const REMINDER_API = "https://reminder.philip.business/api/agent"

export async function createChatReminder(text, source = "") {
  const key = loadSshSettings().reminderAgentKey?.trim()
  if (!key) throw new Error("Kein Reminder Agent-Key konfiguriert")
  const content = `${text.trim()}${source ? `\n\nQuelle: ${source}` : ""}`
  const response = await fetch(`${REMINDER_API}/entries`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${key}` },
    body: JSON.stringify({ content, type: "todo" }),
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.error || `Reminder API: ${response.status}`)
  return data
}

export function parseSlashCommand(text) {
  const match = text.trim().match(/^\/(summarize|todo|vault)(?:\s+([\s\S]*))?$/i)
  return match ? { command: match[1].toLowerCase(), argument: (match[2] || "").trim() } : null
}
